export const environment = {
  TENANT:'cpl',
  production: false,
  KC_URL:'https://dev-auth.pjm.gob.ar/auth/',
  KC_CLIENT_ID:'skipper',
  KC_REALM:'devops',
  KEYCLOAK_AUTH_ADDRESS_ENC:'http%3A%2F%2Fdev-auth.pjm.gob.ar%2Fauth%2Frealms%2Fdevops%2Fprotocol%2Fopenid-connect%2Fauth%3Fclient_id%3Dskipper%26nonce%3Dte7s5t9t%26response_mode%3Dfragment%26response_type%3Dcode%26login%3Dtrue%26redirect_uri%3Dhttps%3A%2F%2Fdev-skipper-uploader.pjm.gob.ar%2F',
  // BACK_INITIAL:"https://dev-backend.pjm.gob.ar/skipper-fix-initial-master/api/v1.0/initial/",
  BACK_INITIAL:"https://dev-skipper-initial.bknd.pjm.gob.ar/skipper-fix-initial-master/api/v1.0/initial/",
  BACK_DOWNLOADER:"https://dev-backend.pjm.gob.ar/skipper-download/cpl/",
  BACK_JUZGADOS:"https://dev-backend.pjm.gob.ar/skipper-validation-cpl-master/juzgado/",
  BACK_TIPO_ACTO:"https://dev-backend.pjm.gob.ar/skipper-validation-cpl-master/tipo-acto/",
  URL_PARAMETER_SEPARATOR_DOWNLOAD:'%2',
  URL_DOWNLOADER:'https://dev-skipper-downloader.pjm.gob.ar/cpl/',
  ACCEPTED_FILE_FORMATS:["pdf","doc","docx","odt","xls","xlsx","avi","mp4","m4v","wmv", "jpg", "jpeg", "png", "webp"],
  ACCEPTED_DD_FILE_FORMATS:["pdf","doc","docx","odt","xls","xlsx", "jpg", "jpeg", "png", "webp"],
  VIDEO_FILE_FORMATS:["mp4","wmv"],
  BACK_BANDEJA:"https://dev-backend.pjm.gob.ar/skipper-bandeja/cpl/api/v1.0/bandeja-subidos/",
  BACK_USUARIOS_DE_OFICINA:"https://dev-backend.pjm.gob.ar/skipper-bandeja/cpl/api/v1.0/usuarios-de-oficina/",
  BACK_BORRA_DOCUMENTO_VIDEO:"https://dev-backend.pjm.gob.ar/skipper-bandeja/cpl/api/v1.0/marca-borrado/",
  BACK_DIRECT_DOWNLOAD:'https://dev-s.pjm.gob.ar/dd/cpl/',
  NO_META4_USER_MESSAGE:'Su usuario no tiene permiso para utilizar esta aplicación, por favor solicítelo generando un Ticket enviando Nombre, Apellido, Nombre de Usuario, DNI y Lugar de Trabajo en https://devops-pjm.freshdesk.com',
  NETWORK_CONN_ISSUE_MESSAGE:"Parece que hay problemas con la red del Poder Judicial y SKIPPER no puede conectarse correctamente a internet.",
  BACK_EDITAR:"https://dev-backend.pjm.gob.ar/skipper-bandeja/cpl/api/v1.0/modifica-documento/"
}

  